import ResendSmsButton from "./ResendSmsButton";

export default ResendSmsButton;
